export const DownloadSvg = () => (<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 11V13H13V11H14V13C14 13.2652 13.8946 13.5196 13.7071 13.7071C13.5196 13.8946 13.2652 14 13 14H1C0.734784 14 0.48043 13.8946 0.292893 13.7071C0.105357 13.5196 0 13.2652 0 13V11H1ZM8 0V8L10 6L11.5 7.5L7 12L2.5 7.5L4 6L6 8V0H8Z" fill="#1F1F1F" />
</svg>
)